"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    CommitmentOf: {
      duration: 'LockDuration',
      amount: 'BalanceOf',
      candidate: 'AccountId'
    },
    Era: {
      index: 'u32',
      start: 'BlockNumber'
    },
    LockDuration: {
      _enum: ['OneMonth', 'OneYear', 'TenYears']
    }
  }
};
exports.default = _default;